import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateStatus',
})
export class TranslateStatusPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: boolean | string): string {
    if (typeof value === 'boolean' || value === 'true') {
      return value
        ? this.translateService.instant('+INSTALLATIONS.INSTALLATION.GATEWAY_STATUS.STATUS.ONLINE')
        : this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.GATEWAY_STATUS.STATUS.OFFLINE'
          );
    }

    return '';
  }
}
